var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73362 0.918516L4.54987 1.28346H2.09987C1.64815 1.28346 1.2832 1.64841 1.2832 2.10013C1.2832 2.55185 1.64815 2.9168 2.09987 2.9168H11.8999C12.3516 2.9168 12.7165 2.55185 12.7165 2.10013C12.7165 1.64841 12.3516 1.28346 11.8999 1.28346H9.44987L9.26612 0.918516C9.12831 0.640339 8.84503 0.466797 8.53622 0.466797H5.46352C5.15471 0.466797 4.87143 0.640339 4.73362 0.918516ZM11.8999 3.73346H2.09987L2.64091 12.385C2.68174 13.0307 3.21768 13.5335 3.86336 13.5335H10.1364C10.7821 13.5335 11.318 13.0307 11.3588 12.385L11.8999 3.73346Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImage);
export default __webpack_public_path__ + "static/media/delete-image.e311a7848f6de68b9a5dc2565a3178b6.svg";
export { ForwardRef as ReactComponent };